import { Text } from "@chakra-ui/react";

export default function Milestones(){
    return(
        <div style={{textAlign:"justify"}}>
        <Text>
            If you're reading this,
            <br/>it's because we are both here. 
            <br/>
            <br/>Because I didn't give up,
            <br/>And you were willing to see 
            <br/>what not giving up looks like.
            <br/>
            <br/>What it means to make something
            <br/>of yourself,
            <br/>for yourself, and for others.
            <br/>
            <br/>There may be expectations,
            <br/>set for you,
            <br/>by yourself and by others.
            <br/>- What does it look like when you put aside
            <br/>those Expectations?
            <br/>those Barriers?
            <br/>When you move in your way, without them.
            <br/>Can you make something of that?
            <br/>Did you find a question?
            <br/>Did you find any Joy?
            <br/>any Hope?
            <br/>
            <br/>Thanks for reading. - MM
        </Text>
        </div>
    )
}